import React from "react";
import { ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import NavLink from "../CustomLink/index";

type IProps = {
  icon?: React.ReactElement;
  primary: string;
  to: string;
};

function ListItemLink(props: IProps) {
  const { icon, primary, to } = props;

  return (
    <ListItem
      to={to}
      component={NavLink}
      sx={{ marginBottom: "17px" }}
      target={primary === "chat" ? "_blank" : "_self"}
    >
      {icon ? <ListItemIcon sx={{ color: "transparent" }}>{icon}</ListItemIcon> : null}
      <ListItemText primary={<Typography>{primary}</Typography>} />
    </ListItem>
  );
}

export default ListItemLink;
